/*
 * Analytics services wrapper
 *
 * FOSSA currently uses:
 * - Heap
 * - Rudderstack
 * - PostHog
 */

import { window } from '../globals';
import type { Organization } from '../types';

export const track = (eventName: string, eventProps: Record<string, string | number | boolean>) => {
  if (window.heap) {
    window.heap.track(eventName, eventProps);
  }
  if (window.rudderanalytics) {
    window.rudderanalytics.track(eventName, eventProps);
  }
  if (window.posthog) {
    window.posthog.capture(eventName, eventProps);
  }
};

export const getBaseOrgProperties = () => {
  const organization = window.user?.organization || {} as Organization;

  return {
    organization: organization.title || '',
    organizationId: organization.id || '',
    access_level: organization.access_level || '',
    custom_billing: organization.custom_billing || '',
    stripe_plan: organization.stripe_plan || '',
  };
};
